'use strict';
const angular = require('angular');

export class sliderUploadComponent {
  /*@ngInject*/
  constructor(Upload, Auth, Config, $scope) {
    this.Upload = Upload;
    this.Auth = Auth;
    this.isAdmin = this.Auth.isAdminSync;

    this.myImage='';
    this.myCroppedImage='';

    var handleFileSelect=(evt) => {
      var file=evt.currentTarget.files[0];
      this.filename = file.name;
      var reader = new FileReader();
      reader.onload = (evt) => {
        $scope.$apply(($scope) => {
          this.myImage=evt.target.result;
        });
      };
      reader.readAsDataURL(file);
    };
    angular.element(document.querySelector('#fileInput')).on('change',handleFileSelect);
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok() {
    this.close({$value: this.storageId});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  uploadFile() {
    var that = this;

    this.Upload.upload({
      url: '/api/storage',
      data: {
        name: this.filename,
        file: this.Upload.dataUrltoBlob(this.myCroppedImage, this.filename),
        isPublic: true,
        permission: [],
        storageStrategy: 'local',
        creationUser: this.Auth.getCurrentUserSync()._id,
        active: true
      }
    }).then(function (response) {
      that.storageId = response.data;
      that.ok();

    }, function (response) {
      if (response.status > 0) {
        alert(response.status + ': ' + response.data);
      }
    });
  }

}

export default angular.module('conduu.admin.sliderUploadComponent', [])
  .component('sliderUpload', {
    template: require('./slider-upload.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: sliderUploadComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/slider-upload/slider-upload.component.js